import { Segmented } from 'antd';
import { usePanelMode } from 'contexts/PanelModeContext';
import { useLocation, useNavigate } from 'react-router-dom';
import { getPanelModeFromPathname, PanelMode } from 'utils/panelRoutes';
import styles from './index.module.scss';

type PanelModeToggleProps = {
  compact?: boolean;
};

const PanelModeToggle = ({ compact = false }: PanelModeToggleProps) => {
  const { panelMode, switchPanel, showPanelToggle } = usePanelMode();
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const displayPanelMode = getPanelModeFromPathname(pathname) ?? panelMode;

  if (!showPanelToggle) return null;

  const options = [
    { label: 'Med Panel', value: 'medicine' as PanelMode },
    { label: 'Grocery Panel', value: 'grocery' as PanelMode },
  ];

  return (
    <div
      className={
        compact ? styles['panel-toggle--compact'] : styles['panel-toggle']
      }
    >
      <Segmented
        options={options}
        value={displayPanelMode}
        onChange={(value) => {
          const mode = value as PanelMode;
          navigate(switchPanel(mode), { replace: true });
        }}
      />
    </div>
  );
};

export default PanelModeToggle;
